import { saveAs } from "file-saver";

export interface SaveBlobWithDialogOptions {
	blob: Blob;
	fileName: string;
	mimeType?: string;
	contentType?: string;
}

interface FileSystemWritableFileStreamLike {
	write: (data: Blob) => Promise<void>;
	close: () => Promise<void>;
}

interface FileSystemFileHandleLike {
	createWritable: () => Promise<FileSystemWritableFileStreamLike>;
}

type ShowSaveFilePicker = (options: {
	suggestedName?: string;
	types?: Array<{
		description: string;
		accept: Record<string, string[]>;
	}>;
}) => Promise<FileSystemFileHandleLike>;

export async function saveBlobWithDialog(
	blobOrOptions: Blob | SaveBlobWithDialogOptions,
	fileName?: string,
	contentType?: string,
): Promise<void> {
	const blob =
		blobOrOptions instanceof Blob ? blobOrOptions : blobOrOptions.blob;
	const resolvedFileName =
		blobOrOptions instanceof Blob
			? fileName ?? "download"
			: blobOrOptions.fileName;
	const resolvedContentType =
		blobOrOptions instanceof Blob
			? (contentType ?? blob.type) || "application/octet-stream"
			: (blobOrOptions.mimeType ??
					blobOrOptions.contentType ??
					blob.type) ||
			  "application/octet-stream";

	const picker = (
		window as Window & { showSaveFilePicker?: ShowSaveFilePicker }
	).showSaveFilePicker;

	if (typeof picker === "function") {
		try {
			const extension = resolvedFileName.includes(".")
				? `.${resolvedFileName.split(".").pop()}`
				: "";
			const handle = await picker({
				suggestedName: resolvedFileName,
				types: [
					{
						description: resolvedContentType,
						accept: {
							[resolvedContentType]: extension ? [extension] : [],
						},
					},
				],
			});
			const writable = await handle.createWritable();
			await writable.write(blob);
			await writable.close();
			return;
		} catch (err) {
			if ((err as DOMException)?.name === "AbortError") return;
		}
	}

	saveAs(blob, resolvedFileName);
}
